/// <amd-module name="Environments/EnvironmentDetails/Stores/EnvironmentChecksStore" />
import { EnvironmentChecksActions } from "Actions/EnvironmentChecksActions";
import { EnvironmentInstance } from "DistributedTask/Client/Contracts/TaskAgent";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { IStoreState, StoreBase } from "Environments/Flux/Store";

export interface IEnvironmentChecksStoreState extends IStoreState {
    environment: EnvironmentInstance;
}

export class EnvironmentChecksStore extends StoreBase {
    public static getKey(): string {
        return "environment-checks-store";
    }

    public initialize(instanceId: string): void {
        super.initialize(instanceId);

        this._actionsHub = ActionsHubManager.GetActionsHub<EnvironmentChecksActions>(EnvironmentChecksActions, instanceId);
        this._actionsHub.setEnvironment.addListener(this._handleSetEnvironment);
    }

    protected disposeInternal(): void {
        this._actionsHub.setEnvironment.removeListener(this._handleSetEnvironment);
    }
    
    public getState(): IEnvironmentChecksStoreState {
        return this._state;
    }

    public getEnvironment(): EnvironmentInstance {
        return this._state.environment;
    }
    
    private _handleSetEnvironment = (environment: EnvironmentInstance) => {
        this._state.environment = environment;
        this.emitChanged();
    }

    private _actionsHub: EnvironmentChecksActions;
    private _state: IEnvironmentChecksStoreState = {} as IEnvironmentChecksStoreState;
}
